<template>
    <div class="page-container">
        <h2 class="page-title">Page Not Found</h2>

        <p>This page could not be found. Please check your URL and try again.</p>
    </div>
</template>

<style scoped>
.page-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 64px;
}
.page-title {
    text-align: center;
    color: #ec008c;

    font-size: 32px;
    font-weight: 500;
}
</style>